/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".example-tree-invisible[_ngcontent-%COMP%]{display:none}.example-tree[_ngcontent-%COMP%]   li[_ngcontent-%COMP%], .example-tree[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin-top:0;margin-bottom:0;list-style-type:none;font-size:small}.container-sidenav[_ngcontent-%COMP%]{margin:0;padding:0}.container-fluid[_ngcontent-%COMP%]{height:100%;width:100%;padding:0;margin:0}"];
export { styles as styles };
